// ComponentValidationsForm.jsx
// Created: 2025-11-17
// Purpose: Component validation management form - allows adding/removing validation rules from components

import React, { useState } from 'react';
import ValidationModal from './ValidationModal';

const ComponentValidationsForm = ({ component, onUpdate }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const validations = component.validations || [];

  const handleAddValidation = (validation) => {
    const newValidations = [...validations, validation];
    onUpdate({
      ...component,
      validations: newValidations
    });
    setIsModalOpen(false);
  };

  const handleRemoveValidation = (index) => {
    const newValidations = validations.filter((_, i) => i !== index);
    onUpdate({
      ...component,
      validations: newValidations
    });
  };

  return (
    <div>
      {/* Display existing validations */}
      {validations.length > 0 && (
        <div style={{ marginBottom: '12px' }}>
          {validations.map((validation, index) => (
            <div 
              key={index}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '8px 12px',
                backgroundColor: '#F0F9FF',
                border: '1px solid #BAE6FD',
                borderRadius: '6px',
                marginBottom: '8px'
              }}
            >
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '13px', fontWeight: '600', color: '#0369A1' }}>
                  {validation.validationName}
                </div>
                <div style={{ fontSize: '11px', color: '#0891B2', marginTop: '2px' }}>
                  Type: {validation.validationType?.replace(/_/g, ' ')}
                </div>
              </div>
              <button
                onClick={() => handleRemoveValidation(index)}
                style={{
                  padding: '4px 8px',
                  fontSize: '12px',
                  backgroundColor: 'transparent',
                  border: '1px solid #FCA5A5',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  color: '#DC2626'
                }}
                title="Remove validation"
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Add Validation Button */}
      <button
        onClick={() => setIsModalOpen(true)}
        style={{
          width: '100%',
          padding: '10px',
          backgroundColor: '#3B82F6',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          fontSize: '13px',
          fontWeight: '600',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '6px'
        }}
      >
        <span>➕</span>
        Add Validation
      </button>

      {/* Validation Modal */}
      {isModalOpen && (
        <ValidationModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onApply={handleAddValidation}
          componentType={component.type}
        />
      )}
    </div>
  );
};

export default ComponentValidationsForm;




